define('services/agentsService',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'services/apiCore',
    'models/User'
], function ($, ko, _, apiCore, User) {
    'use strict';

    var agentService = {
        getAgent: function (id) {
            return apiCore.v2.get('/users/' + id, {expand: 'presence,routingStatus,outOfOffice'})
                            .then(function (response) {
                                return new User(response);
                            });
        },

        /**
         * Get a collection of agents from the backend.
         *
         * @param {Object} [options=undefined] An object containing optional arguments
         *  for the service.
         * @param {String|String[]} id - A string or array of strings that represent an ID
         *  for a specific agent to get.
         * @return {Promise} A promise object that will resolve with passing in a response
         *  object sent from the backend. The "entities" attribute of this object be an
         *  array that contains a collection of User objects.
         */
        getAgents: function (options) {
            var parameters = _.assign({
                pageNumber: 1,
                pageSize: 20
            }, options);

            if (_.has(parameters, "name")) {
                parameters.name = $.trim(parameters.name);
            }

            // if we have to do a name search, we need to do a q64 search
            if (!_.isEmpty(parameters.name)) {

                if (!_.isEmpty(parameters.divisionId)) {
                    return this.getAgentsByNameAndDivisionIds(parameters);
                }
                    
                return this.getAgentsByName(parameters);
            }

            return apiCore.v2.get('/users', parameters)
                .then(function (response) {
                    var results = response;
                    results.entities = _.map(response.entities, function (data) {
                        return new User(data);
                    });
                    return results;
                });
        },

        getAgentsByName: function(parameters) {
            if (_.has(parameters, "sortOrder")) {
                if (parameters.sortOrder === "descending") {
                    parameters.sortOrder = "desc";
                } else if (parameters.sortOrder === "ascending") {
                    parameters.sortOrder = "asc";
                }
            }
            var payload = {
                "sortOrder": parameters.sortOrder || "asc",
                "sortBy": "name",
                "pageSize": parameters.pageSize,
                "pageNumber": parameters.pageNumber,
                "query": [{
                        "type": "CONTAINS",
                        "fields": ["name"],
                        "value": (parameters.name || '').toLowerCase()
                    }]
            };

            return this.searchUsers(payload);
        },

        getAgentsByNameAndDivisionIds: function (parameters) {
            var opts = _.assign({
                pageNumber: 1,
                pageSize: 100
            }, parameters);

            if (!opts.divisionId) {
                return this.getUsersByName(parameters);
            }

            if (_.isString(opts.divisionId)) {
                opts.divisionId = [opts.divisionId];
            }

            var payload = {
                "sortOrder": opts.sortOrder || "asc",
                "sortBy": "name",
                "pageSize": opts.pageSize,
                "pageNumber": opts.pageNumber,
                "query": [
                    {
                        "type": "CONTAINS",
                        "fields": ["name"],
                        "value": (opts.name || '').toLowerCase()
                    },
                    {
                        "type": "EXACT",
                        "fields": ["divisionId"],
                        "values": opts.divisionId
                    }
                ]
            };

            return this.searchUsers(payload);
        },

        /**
         * Searches for users that meet the criteria of the query
         *
         * @param {object} query
         *
         * @returns {object} A promise object to handle the asynchronous response
         *                   from the server. When the response is received, you can
         *                   expect the response data to be an observable  array that
         *                   contains a user object and whose attributes are observable by
         *                   knockout.js.
         */
        searchUsers: function (query) {
            // api/v2/users wants ascending/descending but api/v2/users/search requires ASC/DESC
            if (query.sortOrder === 'ascending') {
                query.sortOrder = 'ASC';
            } else if (query.sortOrder === 'descending') {
                query.sortOrder = 'DESC';
            }
            return apiCore.v2.post('/users/search', query)
                .then(function (response) {
                    var results = response;
                    results.entities = _.map(response.results, function (data) {
                        return new User(data);
                    });
                    return results;
                });
        },
    };

    return agentService;

});
